import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAnschrift } from '../../Anschrift.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#rentner

	{
		"rentenversicherung": {
			"name": String,
			"anschrift": Anschrift
		},
		"rentnerSeit": "YYYY-MM-DD",
		"staatlicheRenteMonatlich": schemaBigDecimal
	}

*/
export const schemaEuropaceRentner = z.object({
    rentenversicherung: z.optional(
        z.object({
            anschrift: z.optional(schemaEuropaceAnschrift),
            name: z.optional(z.string()),
        }),
    ),
    rentnerSeit: z.optional(z.string().regex(regex_iso_date)),
    staatlicheRenteMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceRentner = z.infer<typeof schemaEuropaceRentner>;
